<template>
  <v-card
      class="card-modal-calendar"
      color="grey lighten-4"
      min-width="150px"
      flat
  >
    <v-toolbar
        :color="selectedEvent.color"
        dark
        class="position-relative"
    >
      <v-icon class="mr-4">{{ selectedEvent.icon }}</v-icon>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
        <v-card-subtitle class="subtitle-card" color="primary" dark v-bind="attrs" v-on="on">
          {{ selectedEvent.titre }}
        </v-card-subtitle>
        </template>
        <span>{{ selectedEvent.titre }}</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-icon small color="lighten-2" @click="$emit('closeEvent', selectedEvent)" icon class="close-btn-modal">
        mdi-close
      </v-icon>
    </v-toolbar>
      <v-img
              v-if="selectedEvent.picture"
              :src="selectedEvent.picture"
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="100px"
              cover
      >
      </v-img>
      <div v-else class="without-picture">
        <span class="mdi mdi-camera-off-outline"></span>
      </div>
    <v-card-text class="mb-3">
      <p v-if="getcaption">{{ getcaption }}</p>
    </v-card-text>
    <v-card-actions class="d-flex justify-space-between align-items-center">
      <router-link class="font-italic" v-if="!checkIsBienVendu && !isPostEdito" :to="{path: `posts/manage-posts/${selectedEvent.annonces[0]}`, query: { network: getSelectedNameNetwork, bienVendu: checkIsBienVendu }}">
        <ButtonModalCalendar :selectedEvent="selectedEvent" content="Editer le post" color="#46A3B9" icon="mdi-pen" />
      </router-link>
      <router-link class="font-italic" v-else-if="!checkIsBienVendu && isPostEdito" :to="`/new_socialnetwork_post/edit-editorial/${selectedEvent.annonces[0]}`">
        <ButtonModalCalendar :selectedEvent="selectedEvent" content="Editer le post" color="#46A3B9" icon="mdi-pen" />
      </router-link>
      <router-link class="font-italic" v-else :to="{path: `posts/bien-vendu/${selectedEvent.annonces[0]}/edit`, query: { network: getSelectedNameNetwork, bienVendu: checkIsBienVendu }}" >
        <ButtonModalCalendar :selectedEvent="selectedEvent" content="Editer le post" color="#46A3B9" icon="mdi-pen" />
      </router-link>
      <ButtonModalCalendar :selectedEvent="selectedEvent" content="Planifier" color="gray" icon="mdi-calendar-clock-outline" @actions="$emit('scheduledEventCalendar', ['Scheduled', selectedEvent])"/>
      <ButtonModalCalendar :selectedEvent="selectedEvent" content="Supprimer" color="red" icon="mdi-delete" @actions="$emit('deleteEventCalendar', ['Delete', selectedEvent])"/>
    </v-card-actions>
  </v-card>
</template>
<script>
import ButtonModalCalendar from '@/pages/calendar/components/ButtonModalCalendar.vue'
export default {
  name: 'CardModalCalendar',
  props: ['selectedEvent', 'events'],
  components: {
    ButtonModalCalendar
  },
  data () {
    return {
      editCloseDialog: false
    }
  },
  computed: {
    getSelectedNameNetwork () {
      return this.selectedEvent.portails[0].code.split('_')[0]
    },
    checkIsBienVendu () {
      const arrayNamePortal = this.selectedEvent.portails[0].code.split('_')
      return arrayNamePortal[arrayNamePortal.length - 1] === 'VENDUS'
    },
    isPostEdito () {
      return this.selectedEvent &&
          this.selectedEvent.portails &&
          this.selectedEvent.portails.length > 0 &&
          this.selectedEvent.portails[0] &&
          this.selectedEvent.portails[0].code &&
          this.selectedEvent.portails[0].code.endsWith('_EDITO')
    },
    getcaption () {
      const arrayEvent = Object.keys(this.selectedEvent)
      const caption = arrayEvent.filter((name) => name.includes('_caption') || name.includes('_commentary') || name.includes('_localpost_summary'))
      let nameCaption = ''
      if (Array.isArray(caption)) {
        nameCaption = caption[0]
      } else {
        nameCaption = caption
      }
      return this.selectedEvent[nameCaption]
    }
  }
}
</script>
<style scoped>
.card-modal-calendar {
    max-width: 200px;
}
.v-card__text {
  color: #1A4A56;
  background-color: #EBF3F2 !important;
  height: 110px;
}

.v-card__subtitle{
  padding: 5px 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}

.close-btn-modal {
  position: absolute;
  top: -20px;
  right: -10px;
}

p {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
}

.without-picture{
  height: 100px;
  background: #FDEFDF;
  display: flex;
  justify-content: center;
  align-items: center;
}

.without-picture span{
  font-size: 80px;
  color: #1A4A56;
}
</style>
